import type { Movie } from "@/types/movie";

// 演示数据：片名与人物均为虚构示例，仅用于展示页面结构与交互效果。
export const movies: Movie[] = [
  {
    id: "red-silk-night",
    title: "红绸之夜",
    originalTitle: "붉은 비단의 밤",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20film%20noir%20poster%2C%20elegant%20woman%20in%20deep%20red%20silk%20dress%20inside%20an%20old%20fabric%20shop%2C%20moody%20low-key%20lighting%2C%20charcoal%20shadows%2C%20red%20accent%20glow%2C%20atmospheric%2C%20artistic%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-01&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20interior%20of%20an%20old%20fabric%20shop%20filled%20with%20deep%20red%20silk%2C%20moody%20low-key%20lighting%2C%20charcoal%20shadows%2C%20atmospheric%20film%20noir%20backdrop%2C%20elegant%2C%20no%20text&width=1920&height=900&seq=kfilm-bd-01&orientation=landscape",
    director: "金敏秀",
    cast: ["李智恩", "崔浩然", "韩素英"],
    year: 2019,
    duration: 118,
    rating: 8.4,
    genres: ["情欲", "剧情"],
    tags: ["年代", "爱情", "悬疑"],
    categoryIds: ["eros", "highrating", "classic"],
    synopsis:
      "一件在旧城绸缎铺里流传多年的红绸，把两个各自背负秘密的人牵到一起。夜色与误会交织，他们在试探与靠近之间反复拉扯，最终要面对一个关于信任与原谅的抉择。",
    views: 128500,
    favorites: 3420,
    featured: true,
  },
  {
    id: "han-river-love",
    title: "汉江之恋",
    originalTitle: "한강의 연인",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20romantic%20film%20poster%2C%20couple%20silhouette%20by%20the%20Han%20river%20at%20dusk%2C%20soft%20golden%20haze%2C%20distant%20city%20lights%20reflected%20on%20water%2C%20warm%20melancholic%20mood%2C%20artistic%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-02&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20view%20of%20the%20Han%20river%20at%20dusk%2C%20soft%20golden%20haze%2C%20distant%20city%20skyline%20lights%20reflecting%20on%20calm%20water%2C%20warm%20romantic%20melancholy%2C%20no%20text&width=1920&height=900&seq=kfilm-bd-02&orientation=landscape",
    director: "朴正宇",
    cast: ["徐允儿", "姜泰河"],
    year: 2021,
    duration: 112,
    rating: 7.9,
    genres: ["爱情", "治愈"],
    tags: ["都市", "温暖", "缘分"],
    categoryIds: ["latest", "drama"],
    synopsis:
      "每天清晨在汉江边慢跑的两个人，因为一只走失的狗而相识。平淡的日子里，他们用最寻常的问候慢慢靠近，也在现实的转折前学会勇敢地说出心意。",
    views: 96500,
    favorites: 2180,
    featured: true,
  },
  {
    id: "seoul-night",
    title: "首尔夜未眠",
    originalTitle: "서울의 밤",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20urban%20drama%20poster%2C%20woman%20gazing%20out%20a%20rain-streaked%20window%20at%20night%2C%20neon%20reflections%20on%20wet%20street%2C%20moody%20low-key%20lighting%2C%20deep%20red%20accent%2C%20introspective%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-03&orientation=portrait",
    director: "郑恩彩",
    cast: ["文佳英", "白真熙", "李承宇"],
    year: 2020,
    duration: 105,
    rating: 7.6,
    genres: ["情欲", "都市"],
    tags: ["夜生活", "情感", "孤独"],
    categoryIds: ["eros", "latest"],
    synopsis:
      "深夜电台的主持人收留了一位淋雨的陌生客人。一个雨夜、一次倾诉，让两个原本毫无交集的人短暂地交换了彼此的孤独，也留下了难以言说的余韵。",
    views: 88200,
    favorites: 1960,
  },
  {
    id: "rose-pact",
    title: "蔷薇契约",
    originalTitle: "장미의 계약",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20crime%20drama%20poster%2C%20elegant%20woman%20in%20a%20dark%20tailored%20coat%20holding%20a%20single%20red%20rose%2C%20rain-soaked%20alley%2C%20dramatic%20low-key%20lighting%2C%20charcoal%20palette%2C%20tense%20atmosphere%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-04&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Rain-soaked%20narrow%20Seoul%20alley%20at%20night%2C%20wet%20cobblestones%20reflecting%20deep%20red%20neon%2C%20moody%20noir%20atmosphere%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1920&height=900&seq=kfilm-bd-03&orientation=landscape",
    director: "崔成勋",
    cast: ["申敏儿", "张赫", "柳俊烈"],
    year: 2018,
    duration: 122,
    rating: 8.1,
    genres: ["剧情", "犯罪"],
    tags: ["复仇", "悬疑", "阴谋"],
    categoryIds: ["drama", "highrating", "thriller"],
    synopsis:
      "一桩尘封十年的旧案，因一枚蔷薇徽章再度浮出水面。身为检察官的她为了替母亲讨回公道，不得不与最危险的对手达成一份危险的契约。",
    views: 143200,
    favorites: 4100,
    featured: true,
  },
  {
    id: "evening-wind",
    title: "晚风知我意",
    originalTitle: "저녁 바람",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20gentle%20romance%20poster%2C%20young%20woman%20walking%20through%20a%20sunlit%20rural%20field%20at%20golden%20hour%2C%20wind%20in%20her%20hair%2C%20warm%20soft%20light%2C%20nostalgic%20calm%20mood%2C%20artistic%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-05&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Sunlit%20rural%20Korean%20countryside%20field%20at%20golden%20hour%2C%20gentle%20wind%20through%20tall%20grass%2C%20warm%20nostalgic%20light%2C%20wide%20cinematic%20landscape%2C%20no%20text&width=1920&height=900&seq=kfilm-bd-04&orientation=landscape",
    director: "韩智苑",
    cast: ["金高银", "朴叙俊"],
    year: 2022,
    duration: 109,
    rating: 8.3,
    genres: ["爱情", "治愈"],
    tags: ["乡村", "初恋", "慢生活"],
    categoryIds: ["latest", "highrating"],
    synopsis:
      "为了办理祖父的旧宅，她回到了海边的小镇，遇见了那个留在原地的少年。晚风穿过稻田，把埋藏多年的心事与误会一页页吹开。",
    views: 152300,
    favorites: 4720,
    featured: true,
  },
  {
    id: "apartment-affair",
    title: "迷情公寓",
    originalTitle: "아파트",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20mystery%20thriller%20poster%2C%20woman%20standing%20in%20a%20dim%20apartment%20doorway%2C%20slatted%20light%20across%20the%20walls%2C%20moody%20low-key%20lighting%2C%20deep%20red%20and%20charcoal%20tones%2C%20suspenseful%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-06&orientation=portrait",
    director: "李在成",
    cast: ["孙艺珍", "曹政奭"],
    year: 2017,
    duration: 116,
    rating: 7.5,
    genres: ["情欲", "悬疑"],
    tags: ["都市", "秘密", "邻居"],
    categoryIds: ["eros", "thriller"],
    synopsis:
      "一到深夜，隔壁总会传来若有似无的声响。出于好奇，她开始留意那扇始终紧闭的门，却在一步步靠近真相的同时，卷入了别人的生活漩涡。",
    views: 79800,
    favorites: 1740,
  },
  {
    id: "rainy-confession",
    title: "雨季的告白",
    originalTitle: "장마날의 고백",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20coming-of-age%20romance%20poster%2C%20two%20students%20sharing%20one%20umbrella%20in%20heavy%20rain%2C%20school%20gate%20in%20soft%20blur%2C%20muted%20green%20and%20gray%20tones%2C%20tender%20nostalgic%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-07&orientation=portrait",
    director: "吴贤宇",
    cast: ["林允儿", "李栋旭"],
    year: 2016,
    duration: 101,
    rating: 7.2,
    genres: ["爱情", "剧情"],
    tags: ["青春", "遗憾", "毕业"],
    categoryIds: ["classic", "drama"],
    synopsis:
      "毕业前的那个雨季，他把写了很久的信一直收在书包里。多年后重逢，两人才发现当年的那场雨，淋湿的不只是校门口的那条路。",
    views: 66400,
    favorites: 1380,
  },
  {
    id: "twin-blossom",
    title: "双生花",
    originalTitle: "쌍둥이 꽃",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20psychological%20drama%20poster%2C%20two%20mirrored%20silhouettes%20of%20the%20same%20woman%20facing%20each%20other%2C%20split%20lighting%2C%20cold%20cool%20and%20warm%20red%20contrast%2C%20eerie%20elegant%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-08&orientation=portrait",
    director: "金度延",
    cast: ["文瑾莹", "韩孝周"],
    year: 2015,
    duration: 124,
    rating: 8.0,
    genres: ["剧情", "悬疑"],
    tags: ["双胞胎", "身份", "记忆"],
    categoryIds: ["classic", "thriller", "highrating"],
    synopsis:
      "一对自幼分离的双胞胎，在母亲的葬礼上初次相见。当两人交换身份生活，曾经缺席的记忆碎片开始一片片归位，真相远比想象中残酷。",
    views: 91200,
    favorites: 2260,
  },
  {
    id: "edge-of-desire",
    title: "欲望的边界",
    originalTitle: "욕망의 경계",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20erotic%20art%20drama%20poster%2C%20woman%20in%20an%20elegant%20dark%20gown%20against%20a%20deep%20red%20curtain%2C%20dramatic%20low-key%20lighting%2C%20rich%20crimson%20and%20charcoal%20tones%2C%20sensual%20restrained%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-09&orientation=portrait",
    director: "姜允成",
    cast: ["朴敏英", "朱智勋"],
    year: 2023,
    duration: 120,
    rating: 7.8,
    genres: ["情欲", "剧情"],
    tags: ["现代", "抉择", "欲望"],
    categoryIds: ["latest", "eros"],
    synopsis:
      "事业与婚姻都看似完美的她，在一次偶然的重逢里，重新触碰到自己压抑已久的渴望。当诱惑与责任正面相遇，她必须划出属于自己的那条边界。",
    views: 187600,
    favorites: 5340,
  },
  {
    id: "spring-night",
    title: "春夜迷情",
    originalTitle: "봄밤",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20romance%20poster%2C%20couple%20walking%20under%20blooming%20cherry%20blossoms%20at%20night%2C%20soft%20pink%20petals%20in%20the%20air%2C%20warm%20lantern%20glow%2C%20dreamy%20romantic%20mood%2C%20artistic%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-10&orientation=portrait",
    director: "申宇哲",
    cast: ["秀智", "李帝勋"],
    year: 2014,
    duration: 108,
    rating: 7.4,
    genres: ["爱情", "剧情"],
    tags: ["春天", "偶遇", "治愈"],
    categoryIds: ["classic", "drama", "eros"],
    synopsis:
      "春夜的一场偶遇，让两个在生活里各自疲惫的人重新找回心动。花瓣落尽之前，他们约定要把这段短暂却真实的相遇好好记住。",
    views: 71300,
    favorites: 1590,
  },
  {
    id: "silent-witness",
    title: "沉默的证人",
    originalTitle: "침묵의 증인",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20courtroom%20thriller%20poster%2C%20man%20in%20a%20dark%20suit%20standing%20in%20a%20shadowed%20corridor%2C%20single%20harsh%20light%20beam%2C%20cold%20charcoal%20palette%20with%20red%20accent%2C%20tense%20atmosphere%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-11&orientation=portrait",
    director: "郑在勋",
    cast: ["薛景求", "金南珠"],
    year: 2013,
    duration: 130,
    rating: 8.5,
    genres: ["悬疑", "犯罪"],
    tags: ["推理", "法庭", "真相"],
    categoryIds: ["classic", "thriller", "highrating"],
    synopsis:
      "一桩证据链看似完整的命案，却因为唯一的目击者始终沉默而疑点重重。执意追查的律师发现，真相比谎言更需要勇气去面对。",
    views: 168900,
    favorites: 4980,
  },
  {
    id: "undercurrent",
    title: "暗流",
    originalTitle: "암류",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20crime%20thriller%20poster%2C%20man%20in%20a%20long%20coat%20on%20a%20foggy%20night%20harbor%2C%20dim%20streetlamps%2C%20cold%20blue-gray%20with%20deep%20red%20accent%2C%20dark%20tense%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-12&orientation=portrait",
    director: "金成洙",
    cast: ["李政宰", "全度妍"],
    year: 2019,
    duration: 127,
    rating: 8.2,
    genres: ["犯罪", "惊悚"],
    tags: ["卧底", "黑帮", "背叛"],
    categoryIds: ["thriller", "highrating"],
    synopsis:
      "潜伏多年的卧底早已分不清自己属于哪一边。当身份即将暴露，他必须在兄弟情义与职责之间做出选择，而暗处的水流正悄然改变方向。",
    views: 134700,
    favorites: 3760,
  },
  {
    id: "cliff",
    title: "悬崖之上",
    originalTitle: "절벽 위",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20espionage%20thriller%20poster%2C%20lone%20figure%20standing%20at%20the%20edge%20of%20a%20misty%20cliff%20at%20dawn%2C%20vast%20foggy%20landscape%2C%20deep%20red%20dawn%20sky%2C%20dramatic%20lonely%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-13&orientation=portrait",
    director: "罗泓轸",
    cast: ["河正宇", "金泰梨"],
    year: 2021,
    duration: 133,
    rating: 8.6,
    genres: ["悬疑", "动作"],
    tags: ["谍战", "生存", "信任"],
    categoryIds: ["latest", "thriller", "highrating"],
    synopsis:
      "一次本该简单的情报交接，让几位素不相识的人在悬崖边相遇。风雪、猜忌与追捕接踵而至，活着走出去成了唯一的目标。",
    views: 201400,
    favorites: 6120,
  },
  {
    id: "secret-garden",
    title: "秘密花园",
    originalTitle: "비밀의 정원",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20aristocratic%20drama%20poster%2C%20woman%20in%20a%20long%20burgundy%20dress%20in%20an%20overgrown%20walled%20garden%2C%20mist%20and%20soft%20light%2C%20moody%20rich%20red%20and%20green%20tones%2C%20mysterious%20elegant%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-14&orientation=portrait",
    director: "朴赞郁",
    cast: ["申惠善", "玄彬"],
    year: 2012,
    duration: 115,
    rating: 7.7,
    genres: ["情欲", "悬疑"],
    tags: ["庄园", "秘密", "年代"],
    categoryIds: ["eros", "thriller", "classic"],
    synopsis:
      "那座庄园的花园从不对访客开放。受邀前来的女作家在整理旧档案时，无意中读到了主人一家封闭已久的往事，也看清了自己被卷入的位置。",
    views: 82600,
    favorites: 1820,
  },
  {
    id: "tender-trap",
    title: "温柔陷阱",
    originalTitle: "부드러운 덫",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20romantic%20thriller%20poster%2C%20elegant%20woman%20and%20man%20close%20together%20in%20a%20dim%20luxury%20room%2C%20soft%20candlelight%2C%20rich%20red%20and%20gold%20tones%2C%20ambivalent%20tense%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-15&orientation=portrait",
    director: "李允贞",
    cast: ["金敏喜", "赵寅成"],
    year: 2018,
    duration: 111,
    rating: 7.3,
    genres: ["情欲", "剧情"],
    tags: ["骗局", "情感", "都市"],
    categoryIds: ["eros", "drama"],
    synopsis:
      "一场精心设计的接近，本该只是生意。可当谎言越撒越深，设局的人也渐渐分不清，自己递出去的究竟是算计，还是真心。",
    views: 76800,
    favorites: 1650,
  },
  {
    id: "old-love-letter",
    title: "旧情书",
    originalTitle: "오래된 연서",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20nostalgic%20romance%20poster%2C%20hands%20holding%20an%20old%20worn%20letter%20beside%20a%20warm%20desk%20lamp%2C%20autumn%20afternoon%20light%2C%20sepia%20and%20deep%20red%20tones%2C%20tender%20melancholic%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-16&orientation=portrait",
    director: "尹锡浩",
    cast: ["孙允珠", "孔刘"],
    year: 2011,
    duration: 106,
    rating: 7.9,
    genres: ["爱情", "剧情"],
    tags: ["书信", "回忆", "重逢"],
    categoryIds: ["classic", "drama", "highrating"],
    synopsis:
      "整理母亲遗物时，她发现了一封从未寄出的信。循着信上的地址，她找到了信里提到的那个人，也重新读懂了一段被时代拆散的感情。",
    views: 89400,
    favorites: 2130,
  },
  {
    id: "peninsula-past",
    title: "半岛往事",
    originalTitle: "반도의 옛날",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20period%20drama%20poster%2C%20family%20silhouette%20in%20a%20retro%20rural%20village%20alley%20at%20sunset%2C%20aged%20wooden%20houses%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20reflective%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-17&orientation=portrait",
    director: "崔东勋",
    cast: ["宋康昊", "金惠秀"],
    year: 2010,
    duration: 128,
    rating: 8.1,
    genres: ["剧情", "犯罪"],
    tags: ["时代", "家族", "命运"],
    categoryIds: ["classic", "drama", "highrating"],
    synopsis:
      "从上世纪的小渔村到今天的都市，一个家族三代人的选择与秘密被时间的洪流裹挟向前。往事如潮水退去，留下的只有难以割舍的牵挂。",
    views: 112500,
    favorites: 2980,
  },
  {
    id: "moonlight-whisper",
    title: "月光下的私语",
    originalTitle: "달빛 속삭임",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20fantasy%20romance%20poster%2C%20woman%20in%20elegant%20traditional%20hanbok%20under%20a%20full%20moon%2C%20palace%20courtyard%20with%20soft%20mist%2C%20cool%20midnight%20blue%20and%20warm%20red%20lantern%20tone%2C%20dreamy%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-18&orientation=portrait",
    director: "郑志祐",
    cast: ["李知恩", "吕珍九"],
    year: 2020,
    duration: 103,
    rating: 7.5,
    genres: ["爱情", "治愈"],
    tags: ["宫廷", "奇幻", "命运"],
    categoryIds: ["latest", "drama"],
    synopsis:
      "只有在满月之夜，深宫后院的那口古井才会映出另一个时空。她循着水中的私语一次次靠近，却发现对面等着的人，早已与她的命运相连。",
    views: 103800,
    favorites: 2460,
  },
  {
    id: "lies-and-hearts",
    title: "谎言与真心",
    originalTitle: "거짓과 진심",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20romantic%20thriller%20poster%2C%20woman%20and%20man%20standing%20apart%20in%20a%20dim%20modern%20loft%2C%20cold%20window%20light%2C%20deep%20red%20and%20charcoal%20palette%2C%20ambiguous%20tense%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-19&orientation=portrait",
    director: "朴信宇",
    cast: ["金泰希", "周元"],
    year: 2017,
    duration: 114,
    rating: 7.4,
    genres: ["情欲", "悬疑"],
    tags: ["都市", "欺骗", "试探"],
    categoryIds: ["eros", "thriller"],
    synopsis:
      "交往一年的恋人间藏着一个彼此都不愿先开口的谎言。当一次意外的坦白打破了平衡，他们要决定的是：拆穿它，还是继续相信。",
    views: 74500,
    favorites: 1520,
  },
  {
    id: "gangnam-song",
    title: "江南恋歌",
    originalTitle: "강남 연가",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20urban%20romance%20poster%2C%20young%20woman%20in%20a%20stylish%20coat%20under%20neon%20boutique%20signs%20at%20dusk%2C%20glossy%20city%20street%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20hopeful%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-20&orientation=portrait",
    director: "崔荷娜",
    cast: ["韩韶禧", "车银优"],
    year: 2022,
    duration: 107,
    rating: 7.6,
    genres: ["爱情", "都市"],
    tags: ["江南", "梦想", "奋斗"],
    categoryIds: ["latest", "drama"],
    synopsis:
      "在江南打拼的两个年轻人，为各自的梦想匆忙奔波。一次深夜的加班让他们成为彼此唯一的倾听者，也让他们重新思考什么才是真正想要的。",
    views: 118600,
    favorites: 2740,
  },
  {
    id: "unsent-letter",
    title: "未寄出的信",
    originalTitle: "부치지 못한 편지",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20gentle%20drama%20poster%2C%20young%20woman%20sitting%20by%20a%20window%20folding%20a%20letter%20at%20dusk%2C%20soft%20warm%20interior%20light%2C%20muted%20amber%20and%20deep%20red%20tones%2C%20bittersweet%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-21&orientation=portrait",
    director: "金允石",
    cast: ["金所泫", "朴宝剑"],
    year: 2018,
    duration: 99,
    rating: 7.8,
    genres: ["爱情", "剧情"],
    tags: ["遗憾", "成长", "离别"],
    categoryIds: ["drama", "highrating"],
    synopsis:
      "十八岁那年写下的信，在十年后才被重新翻开。那些没来得及说出口的话，究竟是错过了时机，还是从来没有真正准备好。",
    views: 80600,
    favorites: 1880,
  },
  {
    id: "rose-and-gun",
    title: "玫瑰与枪",
    originalTitle: "장미와 총",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20neo-noir%20crime%20poster%2C%20woman%20in%20a%20sharp%20black%20suit%20holding%20a%20red%20rose%2C%20dramatic%20side%20lighting%2C%20deep%20crimson%20and%20charcoal%20palette%2C%20cool%20deadly%20elegant%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-22&orientation=portrait",
    director: "柳承莞",
    cast: ["金泰梨", "崔岷植"],
    year: 2016,
    duration: 126,
    rating: 8.0,
    genres: ["犯罪", "惊悚"],
    tags: ["黑色", "复仇", "冷酷"],
    categoryIds: ["thriller", "highrating", "classic"],
    synopsis:
      "白天她是花店里温柔的女主人，夜晚则游走在城市的暗面。当旧日的仇家重新出现，她必须用一支玫瑰和一把枪，了结所有的账。",
    views: 121300,
    favorites: 3310,
  },
  {
    id: "between-tides",
    title: "潮汐之间",
    originalTitle: "조수 사이",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20art%20drama%20poster%2C%20woman%20standing%20in%20shallow%20water%20on%20a%20misty%20island%20shore%20at%20dawn%2C%20soft%20pale%20light%2C%20deep%20red%20and%20slate%20blue%20tones%2C%20lone%20introspective%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-23&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Misty%20rocky%20island%20shore%20at%20dawn%2C%20shallow%20water%20and%20soft%20pale%20light%2C%20deep%20red%20dawn%20glow%20on%20the%20horizon%2C%20lone%20atmospheric%20cinematic%20wide%20shot%2C%20no%20text&width=1920&height=900&seq=kfilm-bd-05&orientation=landscape",
    director: "李相日",
    cast: ["金泰梨", "刘亚仁"],
    year: 2023,
    duration: 119,
    rating: 7.9,
    genres: ["情欲", "剧情"],
    tags: ["海岛", "命运", "孤独"],
    categoryIds: ["latest", "eros", "highrating"],
    synopsis:
      "为躲避过去，她来到一座只有潮汐知道时间的海岛。与守岛人的相遇，让她重新学会信任，也让她不得不再一次面对被自己抛下的一切。",
    views: 142800,
    favorites: 3980,
    featured: true,
  },
  {
    id: "last-tango",
    title: "最后的探戈",
    originalTitle: "마지막 탱고",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20art%20film%20poster%2C%20elegant%20couple%20dancing%20tango%20in%20a%20dim%20empty%20ballroom%2C%20single%20warm%20spotlight%2C%20deep%20red%20and%20charcoal%20tones%2C%20passionate%20melancholic%20mood%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=kfilm-24&orientation=portrait",
    director: "金基德",
    cast: ["河正宇", "金敏喜"],
    year: 2009,
    duration: 121,
    rating: 8.3,
    genres: ["情欲", "文艺"],
    tags: ["舞蹈", "孤独", "告别"],
    categoryIds: ["classic", "eros", "highrating"],
    synopsis:
      "舞厅即将关闭的最后一晚，两位多年未见的舞伴重逢。一支探戈跳完，他们要说出口的，是挽留，还是那句迟到太久的告别。",
    views: 98700,
    favorites: 2640,
  },
];